export const buttonVariant = {
  hover: {
    scale: 1.1,
  },
  tap: {
    opacity: 0.2,
  },
};
